import AxiosInstance from "./api";

export const SubsidiaryLedgerService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/subsidiary-ledgers/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/subsidiary-ledgers/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/subsidiary-ledgers", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/subsidiary-ledgers/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/subsidiary-ledgers/" + id);
  },
};
